// extracted by mini-css-extract-plugin
module.exports = {"flat-card":"FlatCard_flat-card__7Hzm5","selectable":"FlatCard_selectable___aGoc"};